const PREFIX = 'PROOF_OF_OWNERSHIP_MOBILE';
export default {
    TOGGLE_CHANGED: `${PREFIX}:TOGGLE_CHANGED`
};


// WEBPACK FOOTER //
// ./src/modules/account-connector/components/proof-of-ownership-mobile/actionTypes.js